import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(undefined);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem("mizu-theme");
    return saved || "blue";
  });

  useEffect(() => {
    localStorage.setItem("mizu-theme", theme);
  }, [theme]);

  const setTheme = (newTheme) => {
    setThemeState(newTheme);
  };

  const getColors = () => {
    switch (theme) {
      case "blue":
        return {
          // Layout
          background: "#0a1628",
          cardBg: "rgba(15, 31, 48, 0.6)",
          innerCardBg: "#1a2b3c",
          inputBg: "#0f1f30",

          // Typography
          text: "#ffffff",
          textSecondary: "#BDB9B5",

          // Borders
          border: "#1b3a4b",

          // Brand
          primary: "#00b8f1",
          secondary: "#0060f1",
          danger: "#ff6b6b",

          // Effects
          hoverBg: "rgba(0,184,241,0.1)",
          rowAlt1: "rgba(15,31,48,0.3)",
          rowAlt2: "rgba(10,22,40,0.4)",
          glassEffect: "rgba(15, 31, 48, 0.4)",
          modalOverlay: "rgba(0,0,0,0.6)",

          // Gradients
          gradient: "linear-gradient(90deg, #00b8f1 0%, #0060f1 100%)",

          // Charts
          chartColors: [
            "#00b8f1",
            "#0060f1",
            "#00d4ff",
            "#0080ff",
            "#00a0d4",
            "#0050c8",
          ],
        };

      // case "pastel":
      //   return {
      //     background: "#2a2520",
      //     cardBg: "rgba(42, 37, 32, 0.6)",
      //     innerCardBg: "#3a332c",
      //     inputBg: "#332c25",

      //     text: "#ffffff",
      //     textSecondary: "#d6cfc8",

      //     border: "#4a3f35",

      //     primary: "#FFD7A8",
      //     secondary: "#FFC799",
      //     danger: "#ff8a65",

      //     hoverBg: "rgba(255,215,168,0.15)",
      //     rowAlt1: "rgba(58,51,44,0.4)",
      //     rowAlt2: "rgba(42,37,32,0.5)",
      //     glassEffect: "rgba(42, 37, 32, 0.4)",
      //     modalOverlay: "rgba(0,0,0,0.6)",

      //     gradient: "linear-gradient(90deg, #FFD7A8 0%, #FFC799 100%)",

      //     chartColors: [
      //       "#FFD7A8",
      //       "#FFC799",
      //       "#FFE5C2",
      //       "#FFB88C",
      //       "#FFDBB3",
      //       "#FFB380",
      //     ],
      //   };
       case 'pastel':
        return {
          background: '#0d1e1c',
          cardBg: '#132a27',
          text: '#ffffff',
          textSecondary: '#BDB9B5',
          // border: '#132a27',
          border: '#00776440',
          primary: '#4A9B8E',
          secondary: '#3A8B7E',
          gradient: 'linear-gradient(90deg, #4A9B8E 0%, #3A8B7E 100%)',
          chartColors: ['#4A9B8E', '#3A8B7E', '#5AAB9E', '#2A7B6E', '#6ABBAE', '#1A6B5E'],
          glassEffect: 'rgba(19, 42, 39, 0.5)',
          danger: "#ff4d4f",
          inputBg:"#0d1e1c",
        };

      case "white":
        return {
          background: "#f5f7fa",
          cardBg: "rgba(255,255,255,0.9)",
          innerCardBg: "#f0f4f8",
          inputBg: "#ffffff",

          text: "#1a1a1a",
          textSecondary: "#666666",

          border: "#e0e6ed",

          primary: "#00b8f1",
          secondary: "#0060f1",
          danger: "#ff4d4f",

          hoverBg: "rgba(0,184,241,0.08)",
          rowAlt1: "#ffffff",
          rowAlt2: "#f8fafc",
          glassEffect: "rgba(255,255,255,0.7)",
          modalOverlay: "rgba(0,0,0,0.4)",

          gradient: "linear-gradient(90deg, #00b8f1 0%, #0060f1 100%)",

          chartColors: [
            "#00b8f1",
            "#0060f1",
            "#00d4ff",
            "#0080ff",
            "#00a0d4",
            "#0050c8",
          ],
        };

      default:
        return {
          background: "#0a1628",
          cardBg: "rgba(10, 22, 40, 0.05)",
          text: "#ffffff",
          textSecondary: "#BDB9B5",
          border: "#1b3a4b",
          primary: "#00b8f1",
          secondary: "#0060f1",
          gradient: "linear-gradient(90deg, #00b8f1 0%, #0060f1 100%)",
          chartColors: [
            "#00b8f1",
            "#0060f1",
            "#00d4ff",
            "#0080ff",
            "#00a0d4",
            "#0050c8",
          ],
          glassEffect: "rgba(10, 22, 40, 0.05)",
          modalOverlay: "rgba(0,0,0,0.6)",
        };
    }
  };

  const colors = getColors();

  return (
    <ThemeContext.Provider value={{ theme, setTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
}
